// extracted by css-extract-rspack-plugin
export default {"relatedSettingCard":"fjGSz"};